// Upgrade CTA — shown when the current workspace's tier doesn't meet a
// surface's requirement. Wrap any tier-gated route with:
//
//   MyScaleOnlySurface: {
//     hide: (el, s) => el.call('isScale', s.root),
//     UpgradeBanner: { requires: 'scale' }
//   }
//
// Client-side gating is UX only — the server's credit meter + tier
// guards are authoritative.

import { workspaceTier, tierLabel } from '../functions/tierGate.js'

export const UpgradeBanner = {
  flow: 'y',
  align: 'center center',
  gap: 'Z1',
  padding: 'B',
  margin: 'A auto',
  maxWidth: 'H',
  background: 'overlay',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'line',
  round: 'Z1',
  textAlign: 'center',

  Icon: { icon: 'lock', boxSize: 'B', color: 'caption' },

  Title: {
    tag: 'h2',
    fontSize: 'A',
    fontWeight: '700',
    color: 'title',
    margin: '0',
    text: (el, s) => {
      const req = el.requires || 'scale'
      return `${tierLabel(req)} required`
    }
  },

  Body: {
    tag: 'p',
    fontSize: 'Z1',
    color: 'caption',
    lineHeight: '1.5',
    margin: '0',
    maxWidth: 'G',
    text: (el, s) => {
      const cur = tierLabel(workspaceTier(s.root))
      const req = el.requires || 'scale'
      return `This surface is included in ${tierLabel(req)}. Your workspace is on ${cur}. Upgrade to unlock.`
    }
  },

  CTA: {
    extends: 'Link',
    href: '/admin/billing',
    padding: 'Z1 B',
    round: 'Z',
    background: 'blue',
    color: 'white',
    fontWeight: '600',
    fontSize: 'Z1',
    textDecoration: 'none',
    ':hover': { filter: 'brightness(1.1)' },
    text: 'Upgrade workspace'
  }
}
